import { render, staticRenderFns } from "./JbSupSolicitacao.vue?vue&type=template&id=0bb3e31b&"
import script from "./JbSupSolicitacao.vue?vue&type=script&lang=js&"
export * from "./JbSupSolicitacao.vue?vue&type=script&lang=js&"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&prod&lang=css&"
import style1 from "./JbSupSolicitacao.vue?vue&type=style&index=1&id=0bb3e31b&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports